var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#010101","d":"M47.658,10.104c-0.415-0.363-1.047-0.323-1.411,0.095L24,35.624L1.753,10.2\n\tc-0.365-0.418-0.998-0.458-1.411-0.095c-0.416,0.364-0.458,0.996-0.095,1.411l23,26.285c0.19,0.218,0.465,0.342,0.753,0.342\n\ts0.562-0.124,0.753-0.343l23-26.285C48.116,11.1,48.074,10.468,47.658,10.104z"}));
}

ArrowDown.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"48px","height":"48px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
